import React from 'react';
import { useLocation } from 'react-router-dom';
import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import "./apply.css";
import cImg2 from "../../assets/images/jobicon.png"; // ✅ Updated fallback image
import { generatePublicUrl } from '../../config/image';

function DetailsJopApp() {
    const location = useLocation();
    const { data } = location.state;

    const statusMap = {
        applied: 20,
        'under review': 40,
        shortlisted: 60,
        rejected: 80,
        hired: 100,
    };

    const progress = statusMap[data?.status] || 0;

    return (
        <>
            <div className="job-gg">
                <h2>Application status</h2>
                <Box className sx={{ width: '70%' }}>
                    <Typography variant="body1" gutterBottom style={{ color: "white" }}>
                        Progress ({data?.status} - {progress}%)
                    </Typography>
                    <LinearProgress
                        sx={{
                            '& .MuiLinearProgress-bar': {
                                backgroundColor: 'white',
                            }
                        }}
                        variant="determinate"
                        value={progress}
                    />
                </Box>
            </div>

            <section className='AppliedJobs'>
                <div className='Applied-inner'>
                    <div className='applied-img'>
                        <img
                            src={
                                data?.company?.companyLogo
                                    ? generatePublicUrl(data.company.companyLogo)
                                    : cImg2
                            }
                            alt="Company logo"
                            onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = cImg2;
                            }}
                        />
                    </div>

                    <div className='applied-desc'>
                        <h1>{data?.title}</h1>
                        <h2>{data?.jobRole} ({data?.company?.companyName})</h2>
                        <h3>Description:</h3>
                        <p>{data?.description}</p>
                    </div>
                </div>
            </section>
        </>
    );
}

export default DetailsJopApp;
